import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
const companyID = JSON.parse(localStorage.getItem('companyID'))

  export const getData = createAsyncThunk('appDriverBookingExpense/getData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetTableSummary', params, {mode:'cors'})
     
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const editAttentionRequired  = createAsyncThunk('appDriverBookingExpense/editAttentionRequired', async (AttentionRequired) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/UpdateAttentionRequired', AttentionRequired, {mode:'cors'})
    return response
  })
  
  export const getClientList = createAsyncThunk('appDriverBookingExpense/getClientCardList', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList')
    return response.data
  })
  export const GetEmails = createAsyncThunk('appPassenger/GetEmails', async (ClientId) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetInvoiceEmailAddresses', ClientId, {mode:'cors'})
     
    return response.data
  })
  export const StripeKey = createAsyncThunk('appCardtransactions/StripeKey', async (GetCCDetails) => {
    const response = await axios.post('https://api.zasway.com:8443/Configuration/GetStripeKeyLive', GetCCDetails, {mode:'cors'})
    return response.data 
  })

  export const getInvoiceDue = createAsyncThunk('appDriverBookingExpense/getInvoiceDue', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/InvoiceDeAmount', params, {mode:'cors'})
    return response.data 
  })

  export const getInvoiceDetails = createAsyncThunk('appDriverBookingExpense/getInvoiceDetails', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetInvoiceDetails', params, {mode:'cors'})
    return response.data 
  })
  
  export const getClientCardsList = createAsyncThunk('appDriverBookingExpense/getClientCardsList', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Client/GetClientCreditCards', params, {mode:'cors'})
    return response.data
  })

  export const GetClientCustomerCard = createAsyncThunk('appCreditCardsBooking/GetCustomerCard', async (GetCCDetails) => {
     
    const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/GetClientCustomerCard', GetCCDetails, {mode:'cors'})
      
    return response.data 
  })

  export const getCustomerID = createAsyncThunk('appCreditCardsBooking/getCustomerID', async (GetCCDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/GetClientCustomerID', GetCCDetails, {mode:'cors'})     
  return response.data 
})
export const Payment = createAsyncThunk('appCreditCardsBooking/Payment', async (GetCCDetails) => {
  
  const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/StripePayment', GetCCDetails, {mode:'cors'})
   
  return response.data 
})
  export const getClientCardDetails = createAsyncThunk('appDriverBookingExpense/getClientCardDetails', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/GetClientCreditCardDetails',  params, {mode:'cors'})
    return response.data
  })
  export const ExpireLink = createAsyncThunk('appCardtransactions/ExpireLink', async (GetCCDetails) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/ExpirePaymentLink', GetCCDetails, {mode:'cors'})
    return response.data 
  })
  export const sendReceiptCash = createAsyncThunk('appCashBooking/sendReceipt', async (ClientId) => {
      
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/SendReceiptEmailCashInvoice', ClientId, {mode:'cors'})
     
    return response.data
  })
  export const SendReceiptEmailCashPDF = createAsyncThunk('appCashBooking/sendReceipt', async (ClientId) => {
      
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/SendReceiptEmailCashPDF', ClientId, {mode:'cors'})
     
    return response.data
  })
  export const sendReceiptCard = createAsyncThunk('appCashBooking/sendReceipt', async (ClientId) => {
      
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/SendReceiptEmailCardInvoice', ClientId, {mode:'cors'})
     
    return response.data
  })

  export const SendReceiptCardPDF = createAsyncThunk('appCashBooking/sendReceipt', async (ClientId) => {
      
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/SendReceiptCardPDF', ClientId, {mode:'cors'})
     
    return response.data
  })

  export const GetInvoiceBookingType = createAsyncThunk('appCashBooking/GetInvoiceBookingType', async (ClientId) => {
       
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetInvoiceBookingType', ClientId, {mode:'cors'})
     
    return response.data
  })
  export const sendPaymentEmail = createAsyncThunk('appDriverBookingExpense/sendPaymentEmail', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/SendEmailPaymentLinkInvoice', params, {mode:'cors'})
    return response.data 
  })
  export const GetClientSecret = createAsyncThunk('appCreditCardsBooking/getCustomerID', async (GetCCDetails) => {
      
    const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/InvoiceClientSecret', GetCCDetails, {mode:'cors'})
      
    return response.data 
  })
  export const InvoiceCheckoutPayment = createAsyncThunk('appCreditCardsBooking/getCustomerID', async (GetCCDetails) => {
      
    const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/InvoiceCheckoutPaymentTransaction', GetCCDetails, {mode:'cors'})
      
    return response.data 
  })
  
  export const GetPaymentStatus = createAsyncThunk('appDriverBookingExpense/updateStatus ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/CheckInvoicePaymentStatus', params, { mode: 'cors' })
    return response.data
  })
  export const CheckExistingPayment = createAsyncThunk('appDriver/CheckExistingPayment', async (DocumentTemplate) => {
      
    const response = await axios.post('https://api.zasway.com:8443/Booking/CheckExistingPayment', DocumentTemplate, {mode:'cors'})
     
    return response.data
  })
  export const getPaymentType = createAsyncThunk('appDriverBookingExpense/getPaymentType', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/GetPaymentType', params, { mode: 'cors' })
    return response.data
  })

  export const ClientPaymentAPI = createAsyncThunk('appDriverBookingExpense/ClientPaymentAPI ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/ClientPayment', params, { mode: 'cors' })
    return response.data
  })

  export const AddCardPaymentTransaction = createAsyncThunk('appDriverBookingExpense/AddCardPaymentTransaction ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/AddPaymentTransaction', params, { mode: 'cors' })
    return response.data
  })

  export const AddInvoicePaymentTransaction = createAsyncThunk('appDriverBookingExpense/AddInvoicePaymentTransaction ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/AddInvoicePaymentTransaction', params, { mode: 'cors' })
    return response.data
  })

  export const updateStatus = createAsyncThunk('appDriverBookingExpense/updateStatus ', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/BookingSettle', params, { mode: 'cors' })
    return response.data
  })

  export const getEditData = createAsyncThunk('appDriverBookingExpense/getEditData', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetEditData', params, {mode:'cors'})
       
    return {
      params,
      data: response.data
    }
  })

  export const addInvoice = createAsyncThunk('appDriverBookingExpense/Create',  async (Booking, {dispatch}) => {
     
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/Create', Booking, {mode:'cors'})
      await dispatch(
        getData({
          companyID, 
          userID: 0, 
          id: 0, 
          page: 0, 
          perPage: 10
        })
      )
    return response
  })

  export const addAutoGenerate = createAsyncThunk('appDriverBookingExpense/addAutoGenerate',  async (AutoGenerate) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/CreateAutoGenerate', AutoGenerate, {mode:'cors'})
    return response
  })

  export const editBooking  = createAsyncThunk('appDriverBookingExpense/editBooking', async (Booking) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/Create', Booking, {mode:'cors'})
    return response
  })

  export const getBookingClientRef  = createAsyncThunk('appDriverBookingExpense/getBookingClientRef', async (Booking) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingClientReferencesDetails', Booking, {mode:'cors'})
    
    return response
  })

  export const getBookingClientRefToUpdate  = createAsyncThunk('appDriverBookingExpense/getBookingClientRefToUpdate', async (Booking) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingClientReferencesDetailsToUpdate', Booking, {mode:'cors'})
     
    return response
  })

  export const getBookingInvoice = createAsyncThunk('appDriverBookingExpense/getBookingInvoice', async (params) => {

    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetTableSummary', params, {mode:'cors'})
      
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getAttentionRequired = createAsyncThunk('appDriverBookingExpense/getAttentionRequired', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetTableSummaryAttentionRequired', params, {mode:'cors'})
    return {
      params,
      data: response.data
    }
  })

  export const getGeneratedInvoices = createAsyncThunk('appDriverBookingExpense/getGeneratedInvoices', async (params) => {
      
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetGeneratedInvoices', params, {mode:'cors'})
      
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getAllMonthsInAYear = createAsyncThunk('Common/GetAllMonthList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetAllMonthList', params, {mode:'cors'})
    return response
  })
  
  export const getAllPreviouseYear = createAsyncThunk('Common/GetAllYearSummary', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetAllYearSummary', {mode:'cors'})
    return response
  })

  export const getStatusList = createAsyncThunk('Common/GetInvoiceStatusTypeList', async () => {
     
    const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoiceStatusTypeList', {mode:'cors'})
     
    return response
  })

  export const getallpaymentInvoice = createAsyncThunk('appCardtransactions/getallpaymentInvoice', async (GetCCDetails) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/AllPaymentsInvoice', GetCCDetails, {mode:'cors'})
    return response.data 
  })

  export const getEditInvoice = createAsyncThunk('appDriverBookingExpense/getEditInvoice', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetTableSummaryEditInvoice', params, {mode:'cors'})
    
    return {
      params,
      data: response.data
    }
  })
  
  export const editInvoiceData  = createAsyncThunk('repeatbooking/editInvoiceData', async (Invoice) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/UpdateInvoiceData', Invoice, {mode:'cors'})
    return response
  })

  export const deleteEditInvoice = createAsyncThunk('repeatbooking/deleteEditInvoice', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/DeleteEdit', params.Obj, {mode:'cors'})
      return response
  })

  export const approveGeneratedInvoices  = createAsyncThunk('appDriverBookingExpense/approveGeneratedInvoices', async (GeneratedInvoices) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/ApproveGeneratedInvoices', GeneratedInvoices, {mode:'cors'})
    return response
  })

  export const UnapproveGeneratedInvoices  = createAsyncThunk('appDriverBookingExpense/unapproveGeneratedInvoices', async (GeneratedInvoices) => {
    
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/UnApproveGeneratedInvoices', GeneratedInvoices, {mode:'cors'})
    return response
  })

  export const deleteGeneratedInvoices = createAsyncThunk('repeatbooking/deleteGeneratedInvoices', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/Delete', id, {mode:'cors'})
    return response
  })

  export const getBookingNote = createAsyncThunk('appDriverBookingExpense/getBookingNote', async (Invoice) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetTableSummaryBookingInvoice', Invoice, {mode:'cors'})
    return response.data
  })

  export const ChangeFlagValue = createAsyncThunk('appDriverBookingExpense/ChnageValue', async (params) => {
    return {
      data: params.flag
    }
  })

  export const ChangeDateInEligableClientDatePicker = createAsyncThunk('appDriverBookingExpense/ChangeDateInEligableClientDatePicker', async (params) => {
    return {
      data: params
    }
  })
  export const getBooking = createAsyncThunk('appDriverBookingExpense/getBooking', async (params) => {
 
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetTableSummaryClientBookings', params, {mode:'cors'})
       
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getClientTypeList = createAsyncThunk('Client/getClientTypeList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/GetClientTypeList', params, {mode: 'cors'})
    return response.data
  })

  export const getPaymentTypeList = createAsyncThunk('Client/getPaymentTypeList', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetPaymentTypeList')
    return response.data
  })

  export const getInvoicePeriodList = createAsyncThunk('Client/getInvoicePeriodList', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoicePeriodList')
    return response.data
  })

  export const updateBookingExpense = createAsyncThunk('appDriverBookingExpense/getDeclinedBookExpenses', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DriverBookingExpense/Update', params, {mode:'cors'})
    return response
  })

  export const getDeclineExpenseData = createAsyncThunk('appDriverBookingExpense/getDeclinedBookExpenses', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DriverBookingExpense/GetDeclinedBookExpenses', params, {mode:'cors'})
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getApprovedExpenseData = createAsyncThunk('appDriverBookingExpense/getApprovedBookExpenses', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/DriverBookingExpense/GetApprovedBookExpenses', params, {mode:'cors'})
    
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getPendingExpenseData = createAsyncThunk('appDriverBookingExpense/getPendingExpenseData', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/DriverBookingExpense/GetPendingBookExpenses', params, {mode:'cors'})
     
    return {
      params,
      allData: response.data.allData
    }
  })

  export const getInvoiceData = createAsyncThunk('appDriverBookingExpense/getInvoiceData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Client/GetInvoiceData', params, {mode:'cors'})
    return response.data
  })

  export const getAPIKEY = createAsyncThunk('appDriverBookingExpense/getAPIKEY', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Configuration/GetConfigurationData', params, {mode:'cors'})
    return  response.data
  })

  export const addInvoiceEmail = createAsyncThunk('appDriverBookingExpense/addInvoiceEmail',  async (InvoiceEmail) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/CreateInvoiceEmail', InvoiceEmail, {mode:'cors'})
    return response
  })

  export const getInvEditData = createAsyncThunk('appDriverBookingExpense/getInvEditData',  async (InvoiceData) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetInvEditData', InvoiceData, {mode:'cors'})
    return response.data
  })

  export const getClientImage = createAsyncThunk('appDriver/GetClientImage', async (client) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetClientImage', client, {mode:'cors'})
    return response.data
  })

  export const getGenerateDocumentEmail = createAsyncThunk('appDriver/getGenerateDocumentEmail', async (DocumentTemplate) => {
      
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetGenerateDocumentEmail', DocumentTemplate, {mode:'cors'})
     
    return response.data
  })

  export const getGenerateDocument = createAsyncThunk('appDriver/getGenerateDocument', async (DocumentPDF) => {
     
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetGenerateDocument', DocumentPDF, {mode:'cors'})
    return response.data
  })

  export const getGenerateDocumentExcel = createAsyncThunk('appDriver/getGenerateDocumentExcel', async (DocumentExcel) => {
       
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetGenerateDocumentExcelFixed', DocumentExcel, {mode:'cors'})
      
    return response.data
  })

  export const resetEditData = createAsyncThunk('appDriver/resetEditData', async () => {
    return []
  })

export const appDriverBookingExpenseSlice = createSlice({
  name: 'appDriverBookingExpense',
  initialState: {
    approvedExpenseData: [],
    approvedExpenseTotal: 1,
    approvedExpenseParams: {},
    approvedExpenseAllData: [],
    declineExpenseData: [],
    declineExpenseTotal: 1,
    declineExpenseParams: {},
    declineExpenseAllData: [],
    pendingExpenseData: [],
    pendingExpenseTotal: 1,
    pendingExpenseParams: {},
    pendingExpenseAllData: [],
    approvedBookingInvoiceData: [],
    approvedBookingInvoiceParams: {},
    approvedBookingData: [],
    autoGenerateData: [],
    approvedEditInvoice: [],
    approvedEdit: [],
    approvedBookingParams: {},
    approvedBookingAllData: [],
    approvedAttentionRequiredData: [],
    approvedAttentionRequiredParams: {},
    data: [],
    params: {},
    approvedEditInvoiceData: [],
    approvedEditInvoiceParams: {},
    bookingEditData: [],
    AutoGenerateEditData: [],
    approvedInvoice: [],
    EditData: [],
    invoiceEmailEditData: [],
    flag:0,
    editData: [],
    total: 1,
    allData: [],
    GlobaleDatePicker: [],
    invoiceStatus:[],
    loader: false,
    invTransactionsData: []
  },
  reducers: {},
  extraReducers: builder => {
  builder
    .addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })
    .addCase(getallpaymentInvoice.fulfilled, (state, action) => {
      state.invTransactionsData = action.payload
    })
    .addCase(getInvEditData.fulfilled, (state, action) => {
      state.editData = action.payload
    })
      
    .addCase(getDeclineExpenseData.fulfilled, (state, action) => {
      state.declineExpenseData = action.payload.data
      state.declineExpenseAllData = action.payload.allData
      state.declineExpenseTotal = action.payload.totalPages
      state.declineExpenseParams = action.payload.params
    })

    .addCase(getApprovedExpenseData.fulfilled, (state, action) => {
      state.approvedExpenseData = action.payload.data
      state.approvedExpenseAllData = action.payload.allData
      state.approvedExpenseTotal = action.payload.totalPages
      state.approvedExpenseParams = action.payload.params
    })

    .addCase(getBookingInvoice.pending, (state) => {
      state.loader = true
    })

    .addCase(getBookingInvoice.fulfilled, (state, action) => {
      state.approvedBookingInvoiceData = action.payload.data
      state.approvedBookingInvoiceParams = action.payload.params
      state.total = action.payload.totalPages
      state.loader = false
    })

    .addCase(getGenerateDocument.pending, (state) => {
      state.loader = true
    })

    .addCase(getGenerateDocument.fulfilled, (state) => {
      state.loader = false
    }) 

    .addCase(getGenerateDocumentExcel.pending, (state) => {
      state.loader = true
    })

    .addCase(getGenerateDocumentExcel.fulfilled, (state) => {
      state.loader = false
    })

    .addCase(getAttentionRequired.fulfilled, (state, action) => {
      state.approvedAttentionRequiredData = action.payload.data
      state.approvedAttentionRequiredParams = action.payload.params
    })

    .addCase(getGeneratedInvoices.fulfilled, (state, action) => {
      state.data = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })

    .addCase(getEditInvoice.fulfilled, (state, action) => {
      state.approvedEditInvoice = action.payload.data
      state.approvedEdit = action.payload.data
      state.approvedEditInvoiceData = action.payload.data
      state.approvedEditInvoiceParams = action.payload.params
    })

    .addCase(getBooking.pending, (state) => {
      state.loader = true
    })

    .addCase(getBooking.fulfilled, (state, action) => {
      state.loader = false
      state.approvedBookingData = action.payload.data
      state.approvedBookingParams = action.payload.params
      state.approvedBookingAllData = action.payload.allData
    })

    .addCase(getPendingExpenseData.fulfilled, (state, action) => {
      state.pendingExpenseAllData = action.payload.allData
      state.pendingExpenseParams = action.payload.params
    })

    .addCase(ChangeFlagValue.fulfilled, (state, action) => {
      state.flag = action.payload.data
    })

    .addCase(ChangeDateInEligableClientDatePicker.fulfilled, (state, action) => {
      
      // state.GlobaleDatePicker = action.payload.data.val
      for (const key in action.payload.data) {
        if (Array.isArray(action.payload.data[key])) {
            state.GlobaleDatePicker = action.payload.data[key]
            break // Stop iterating once the array (picker) is found
        }
    }
      state.invoiceStatus = action.payload.data.allStatus
    })
    
    .addCase(approveGeneratedInvoices.fulfilled, (state, action) => {
      state.approvedInvoice = action.payload.data
    })
    
    .addCase(getEditData.fulfilled, (state, action) => {
      state.EditData = action.payload.data
      
    })
    .addCase(resetEditData.fulfilled, (state) => {
      state.EditData = []
    })
  }
})
  
export default appDriverBookingExpenseSlice.reducer